import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { JsonFormData } from './components/custom-form/custom-form.component';
import { ThemeService } from './services/theme.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'slotbooking';

  constructor( private themeService: ThemeService ) {

  }
  ngOnInit() {
    this.themeService.setTheme();
  }
}
